import React, { Fragment, useEffect, useRef, useState } from 'react';
import CustomerListView from '../../../components/front_office/cus_report/CustomerListView';
import AppURL from '../../../constants/AppURL';
import useFetchData from '../../../helpers/useFetch';
import { useReactToPrint } from 'react-to-print';
import CircleBtn from '../../../constants/CircleBtn';
import PrintListCustomerList from '../../../components/front_office/cus_report/report/PrintListCustomerList';

const FrontCustomerListView = ({ setIconsButton }: { setIconsButton: any }) => {
    const [onURL, setOnURL] = useState(AppURL.FrontOfficeURL + 'front/customer/all/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);
    const componentListRef = useRef<HTMLDivElement | null>(null);
    const handlePrintCard = useReactToPrint({
        content: () => componentListRef.current!,
    });

    useEffect(() => {
        setIconsButton(<CircleBtn onClick={handlePrintCard} />);
        return () => setIconsButton(null);
    }, []);
    return (
        <Fragment>
            <CustomerListView
                data={data}
                loading={loading}
                error={error}
                setOnURL={setOnURL}
                handleFormSuccess={refetch}
            />
            <div className='hidden'>
                <div ref={componentListRef}>
                    <PrintListCustomerList data={data} />
                </div>
            </div>
        </Fragment>
    );
};

export default FrontCustomerListView;
